import { render, staticRenderFns } from "./TaskUiComponent.vue?vue&type=template&id=6ad5c310&"
import script from "./TaskUiComponent.vue?vue&type=script&lang=ts&"
export * from "./TaskUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports